import { Link, useLocation } from 'react-router-dom';

function WaitListLink({ childEl }) {
  const location = useLocation();

  // Check if the current path is already "/wait-list"
  const isOnWaitListPage = location.pathname === '/wait-list';

  return isOnWaitListPage ? childEl : <Link to="/wait-list">{childEl}</Link>;
}

export default WaitListLink;
